/**
* 开发者平台首页
*/
<template>
	<div style="display: flex;flex-direction: column; height: 93.5vh; padding: 15px;" class="bg-gray-50">

		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false" style="z-index: 2000;">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div>
			<!-- 实名认证状态 -->
			<div class="bg-white rounded-lg p-6 mb-8" v-show="false">
				<div class="flex items-center justify-between">
					<div class="flex items-center gap-3">
						<span class="px-2 py-1 bg-green-100 text-green-600 rounded text-sm">已认证</span>
						<span class="text-gray-600">企业实名认证</span>
					</div>
					<button class="text-blue-600 hover:text-blue-700 text-sm !rounded-button whitespace-nowrap">
						<!-- 查看认证信息 -->
						{{ $t('language000176') }}
					</button>
				</div>
			</div>

			<!-- API密钥区域 -->
			<div class="grid grid-cols-3 gap-6 mb-8">
				<div class="bg-white rounded-lg p-6 shadow-sm">
					<div class="flex justify-between items-center mb-4">
						<div class="flex items-center">
							<span class="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
								<!-- 正式环境 -->
								{{ $t('language000177') }}
								app_key
							</span>
						</div>
						<button class="text-gray-400 hover:text-gray-600" @click="toggleProductionKey">
							<i :class="showProductionKey ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
						</button>
					</div>
					<div class="flex items-center justify-between bg-gray-50 p-3 rounded">
						<div class="font-mono">
							{{ showProductionKey ? productionKey : '************************' }}
						</div>
						<button class="text-blue-600 hover:text-blue-800 !rounded-button"
							@click="copyKey(productionKey)">
							<i class="far fa-copy"></i>
						</button>
					</div>
				</div>

				<div class="bg-white rounded-lg p-6 shadow-sm">
					<div class="flex justify-between items-center mb-4">
						<div class="flex items-center">
							<span class="bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-sm">
								<!-- 测试环境 -->
								{{ $t('language000178') }}
								app_key
							</span>
						</div>
						<button class="text-gray-400 hover:text-gray-600" @click="toggleTestKey">
							<i :class="showTestKey ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
						</button>
					</div>
					<div class="flex items-center justify-between bg-gray-50 p-3 rounded">
						<div class="font-mono">
							{{ showTestKey ? testKey : '************************' }}
						</div>
						<button class="text-blue-600 hover:text-blue-800 !rounded-button" @click="copyKey(testKey)">
							<i class="far fa-copy"></i>
						</button>
					</div>
				</div>
				
				
				<div class="bg-white rounded-lg p-6 shadow-sm">
					<div class="flex justify-between items-center mb-4">
						<div class="flex items-center">
							<span class="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm">
								clientId
							</span>
						</div>
						<button class="text-gray-400 hover:text-gray-600" @click="toggleshowUserID">
							<i :class="showUserID ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
						</button>
					</div>
					<div class="flex items-center justify-between bg-gray-50 p-3 rounded">
						<div class="font-mono">
							{{ showUserID ? userID : '************************' }}
						</div>
						<button class="text-blue-600 hover:text-blue-800 !rounded-button"
							@click="copyKey(userID)">
							<i class="far fa-copy"></i>
						</button>
					</div>
				</div>
				
			</div>

			<!-- API调用统计 -->
			<div class="bg-white rounded-lg p-6 shadow-sm mb-8">
				<div style="display: flex;">
					<h2 class="text-lg font-medium mb-6">
						<!-- API 调用统计 -->
						{{ $t('language000179') }}
					</h2>

					<span style="flex-grow: 1;"></span>

					<!-- 环境选择 0测试true  1正式false -->
					<el-switch v-model="environmentType" :active-text="$t('language000178')"
						:inactive-text="$t('language000177')" @change="switchingEnvironments" inactive-color="#13ce66">
					</el-switch>

				</div>

				<div class="grid grid-cols-4 gap-6">
					<div class="col-span-3">
						<div class="grid grid-cols-3 gap-4">
							<div class="bg-blue-50 rounded-lg p-4">
								<div class="text-sm text-gray-600 mb-1">
									<!-- 总调用次数 -->
									{{ $t('language000180') }}
								</div>
								<div class="text-2xl font-semibold">{{ totalCallsCounts }}</div>
							</div>
							<div v-show="false" class="bg-green-50 rounded-lg p-4">
								<div class="text-sm text-gray-600 mb-1">
									<!-- 剩余可用额度 -->
									{{ $t('language000181') }}
								</div>
								<div class="text-2xl font-semibold">{{ remainingAvailableCredit }}</div>
							</div>
							<div v-show="false" class="bg-purple-50 rounded-lg p-4">
								<div class="text-sm text-gray-600 mb-1">
									<!-- 使用率 -->
									{{ $t('language000182') }}
								</div>
								<div class="text-2xl font-semibold">{{ callRate }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 产品列表 -->
			<div class="bg-white rounded-lg p-6 shadow-sm">
				<h2 class="text-lg font-medium mb-6">
					<!-- 产品调用明细 -->
					{{ $t('language000183') }}
				</h2>
				<div class="grid grid-cols-3 gap-6">
					<div v-for="product in products" :key="product.id" class="bg-gray-50 rounded-lg p-4">
						<div class="flex items-center mb-4">
							<div class="w-24 h-12 overflow-hidden flex items-center justify-center p-1">
								<img :src="product.image" :alt="product.name" class="h-full object-contain" />
							</div>

							<div class="ml-3">
								<div class="font-medium">{{ product.name }}</div>
								<div class="text-sm text-gray-600">{{ product.category }}</div>
							</div>
						</div>
						<div class="space-y-2">
							<div class="flex justify-between text-sm">
								<span class="text-gray-600">
									<!-- 调用次数 -->
									{{ $t('language000184') }}
								</span>
								<span class="font-medium">{{ product.calls.toLocaleString() }}</span>
							</div>
							<div v-show="false" class="flex justify-between text-sm">
								<span class="text-gray-600">
									<!-- 剩余额度 -->
									{{ $t('language000185') }}
								</span>
								<span class="font-medium">{{ product.remaining.toLocaleString() }}</span>
							</div>
							<div class="w-full bg-gray-200 rounded-full h-2">
								<div class="bg-blue-600 h-2 rounded-full" :style="{ width: product.usage + '%' }"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	// 引入公用方法
	import {
		getError
	} from '../../../../src/utils/StringUtil.js';
	
	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				productionKey: '', //正式环境密钥
				testKey: '', //测试环境密钥
				userID: '', //用户ID
				totalCallsCounts: '', //总调用次数
				remainingAvailableCredit: '', //剩余可用额度
				callRate: '', //调用率
				environmentType: false, //0测试true  1正式false
				showProductionKey: false,
				showTestKey: false,
				showUserID: false,
				products: [{
					id: 1,
					name: 'KeyPod (I)',
					category: '一代钥匙盒',
					calls: 0,
					remaining: 0,
					usage: 0,
					image: require('../../../assets/image_key_pod.png'),
				}, {
					id: 2,
					name: 'KeyPod (II)',
					category: '二代钥匙盒',
					calls: 0,
					remaining: 0,
					usage: 0,
					image: require('../../../assets/image_key_pod2.png'),
				}],
				//...
			};
		},
		mounted() {
			this.getIndexData(); //首页信息
		},
		methods: {
			getIndexData() { //首页信息

				let environmentType01 = "";
				if (this.environmentType) { //数据环境  0测试true  1正式false
					environmentType01 = "0";
				} else {
					environmentType01 = "1";
				}

				this.loadingData = false;
				axios.get(this.$p_url_Developers + '/platform/info/getIndexData/' + environmentType01, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'authorization': Cookies.get("tokenDevelopment"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("后台数据返回：", response.data)
						if (response.data.code === 401) { //登录失效
							Cookies.remove("tokenDevelopment");
							this.$router.push({ //跳转到登录
								path: '/DevelopersLogin',
								query: {}
							});
						} else if (response.data.code === 200) { // 检查状态
							this.testKey = response.data.data.apiSecretKeyDev; //测试环境密钥
							this.productionKey = response.data.data.apiSecretKeyProd; //正式环境密钥
							this.userID = response.data.data.clientId; //用户ID

							this.totalCallsCounts = response.data.data.deviceApiCallsTotalData
								.totalCallsCounts; //总调用次数
							this.remainingAvailableCredit = response.data.data.deviceApiCallsTotalData
								.remainingAvailableCredit; //剩余可用额度
							this.callRate = response.data.data.deviceApiCallsTotalData.callRate; // 调用率


							//黄色Keypod 6  keypod pro 11   cagink 7,cagink pro 10,   绿色little devil 3,Thunderbolt 9
							response.data.data.deviceApiCallsDetailResList.forEach(item => {
								switch (item.typeId) {
									case 6: //一代钥匙盒
										this.products[0].calls = item.callsCount; //调用数
										this.products[0].remaining = item.remainingCallsCount; //总的调用量
										this.products[0].usage = item.callsCount / item.remainingCallsCount *
											100; //调用比例	
										break
									case 11: //二代钥匙盒
										this.products[1].calls = item.callsCount; //调用数
										this.products[1].remaining = item.remainingCallsCount; //总的调用量
										this.products[1].usage = item.callsCount / item.remainingCallsCount *
											100; //调用比例	
										break
								}
							});


						} else {
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			switchingEnvironments(index) { //切换环境
				this.getIndexData(); //首页信息
			},
			toggleProductionKey() {
				this.showProductionKey = !this.showProductionKey;
			},
			toggleTestKey() {
				this.showTestKey = !this.showTestKey;
			},
			toggleshowUserID(){
				this.showUserID = !this.showUserID;
			},
			copyKey(key) {
				const input = document.createElement('input'); // 创建一个临时的输入框
				input.value = key; // 将要复制的内容赋值给输入框
				document.body.appendChild(input); // 将输入框添加到文档中
				input.select(); // 选中输入框中的文本
				input.setSelectionRange(0, 99999); // 对于移动设备
				document.execCommand('copy'); // 执行复制命令
				document.body.removeChild(input); // 移除临时输入框
				this.$message({
					message: this.$t('language000064'),
					type: 'success'
				});
			},
			//...
		},
	};
</script>

<style scoped>
	.bg-gray-50 {
		background-color: #F9FAFB;
	}
</style>